import { Navigate, useParams } from "react-router-dom";

import Hero02 from "./Hero02";
import Mechanism02 from "./Mechanism02";
import Impact02 from "./Impact02";
import Cta02 from "./Cta02";
import { getServiceContent } from "./servicesContent";

import SeoHead from "../../../seo/SeoHead";
import { TITLE_SUFFIX, truncateMetaDescription } from "../../../seo/siteConfig";

function ServicePage() {
  const { serviceSlug } = useParams();
  const content = getServiceContent(serviceSlug);

  if (!content) {
    return <Navigate to="/" replace />;
  }

  const path = `/services/${serviceSlug}`;
  const pageTitle = `${content.heroTitle}${TITLE_SUFFIX}`;

  return (
    <div>
      <SeoHead
        title={pageTitle}
        description={truncateMetaDescription(content.heroSubtitle)}
        path={path}
      />
      <Hero02 title={content.heroTitle} subtitle={content.heroSubtitle} />
      <Mechanism02
        heading={content.mechanismHeading}
        body={content.mechanismBody}
        riveSrc={content.riveSrc}
      />
      <Impact02 cards={content.impactCards} />

      <Cta02 />
    </div>
  );
}

export default ServicePage;
